import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import Button from '../../../../../../../components/button/Button';
import Modal from '../../../../../../../components/modal/Modal';
import {
    CHANGED_PERFOMANCE_MODAL,
    ADDITIONAL_BOOK_MODAL,
    REVERT_MODAL,
    UNTRANSCRIBABLE_MODAL,
} from '../../../../../../../constants/reading/TroConstants';
import './ConfirmationModal.scss';

const getModalsConfiguration = (confirmationModalType, closeModal, revertResult) => {
    switch (confirmationModalType) {
        case UNTRANSCRIBABLE_MODAL:
            return {
                headerModal: 'Audio File not Processed',
                contentModal: (
                    <>
                        The system could not detect the student’s reading so the audio file has not
                        been transcribed.
                        <span className="medium-br" />
                        Listen to the student&apos;s recording to determine where the audio ended
                        and indicate it on the transcript.
                        <span className="medium-br" />
                        Then you can enter scoring information on the transcript as necessary and
                        save your changes.
                        <span className="medium-br" />
                    </>
                ),
                buttonsModal: (
                    <Button
                        dataTestId="modal-understand-btn"
                        className="btn rescoring-primary"
                        text="I understand"
                        onClick={closeModal}
                    />
                ),
            };
        case ADDITIONAL_BOOK_MODAL:
            return {
                headerModal: 'Additional TRO Assessment Required',
                contentModal: (
                    <>
                        <b>
                            Your edits have caused score changes that require this student to
                            complete another TRO book.
                        </b>
                        <span className="medium-br" />
                        If you do not wish to assess this student again, click{' '}
                        <b>Restore Original</b> to delete all edits and restore the original
                        transcript and results.
                    </>
                ),
                buttonsModal: (
                    <>
                        <Button
                            dataTestId="modal-revert-btn"
                            className="btn rescoring-secondary"
                            text="Restore Original"
                            onClick={revertResult}
                        />
                        <Button
                            dataTestId="modal-ok-btn"
                            className="btn rescoring-primary"
                            text="OK"
                            onClick={closeModal}
                        />
                    </>
                ),
            };
        case CHANGED_PERFOMANCE_MODAL:
            return {
                headerModal: 'Final Score Changed',
                contentModal: (
                    <b>
                        Editing the Reading Transcript has resulted in changes to the student’s
                        final score.
                    </b>
                ),
                buttonsModal: (
                    <>
                        <Button
                            dataTestId="modal-revert-btn"
                            className="btn rescoring-secondary"
                            text="Restore Original"
                            onClick={revertResult}
                        />
                        <Button
                            dataTestId="modal-ok-btn"
                            className="btn rescoring-primary"
                            text="OK"
                            onClick={closeModal}
                        />
                    </>
                ),
            };
        case REVERT_MODAL:
            return {
                headerModal: 'Restore Original?',
                contentModal: (
                    <b>Do you want to delete all edits and restore the original transcript?</b>
                ),
                buttonsModal: (
                    <>
                        <Button
                            dataTestId="modal-cancel-btn"
                            className="btn rescoring-secondary"
                            text="Cancel"
                            onClick={closeModal}
                        />
                        <Button
                            dataTestId="modal-ok-btn"
                            className="btn rescoring-primary"
                            text="OK"
                            onClick={revertResult}
                        />
                    </>
                ),
            };

        default:
            return null;
    }
};

const ConfirmationModal = ({ confirmationModalType, isShown, closeModal, revertResult }) => {
    const modalConfiguration = getModalsConfiguration(
        confirmationModalType,
        closeModal,
        revertResult,
    );

    return (
        !isNil(modalConfiguration) && (
            <Modal
                isShown={isShown}
                className="confirmation-modal"
                modalHeader={
                    <>
                        <i className="icon-v2-warning" />
                        {modalConfiguration.headerModal}
                    </>
                }
            >
                <>
                    <p className="modal-text">{modalConfiguration.contentModal}</p>
                    <div className="buttons-wrapper">{modalConfiguration.buttonsModal}</div>
                </>
            </Modal>
        )
    );
};

ConfirmationModal.defaultProps = {
    confirmationModalType: null,
    isShown: false,
    closeModal: () => {},
    revertResult: () => {},
};

ConfirmationModal.propTypes = {
    confirmationModalType: PropTypes.string,
    isShown: PropTypes.bool,
    closeModal: PropTypes.func,
    revertResult: PropTypes.func,
};

export default ConfirmationModal;
